import React from "react";

import { cn } from "./utils/cn";

interface Props extends React.ComponentProps<"button"> {
  loading?: boolean;
  icon: React.ReactNode;
}
export const IconButton = React.forwardRef(function IconButton(
  { icon, className, loading, ...props }: Props,
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  return (
    <button
      ref={ref}
      {...props}
      className={cn("p-1 rounded-[3px] text-primary-1 bg-[#f4f4f4]", className)}
    >
      {loading ? (
        <div
          className={cn(
            "h-5 w-5 animate-spin rounded-full border-4 border-t-transparent text-white"
          )}
        ></div>
      ) : (
        icon
      )}
    </button>
  );
});
